import React, { Component } from 'react';

class PageNoRole extends Component {
    onClick_email(){
        var toAddress = "rendszergazda@kig.hu";
        var subject = "Szeretnék wifi-azonosítókat létrehozni!"
        var body = "Kedves Rendszergazda!\n\nKérlek, állítsd be a wifi-azonosítók létrehozására vontakozó engedélyt a címemre, amit regisztráltam!\n\nKöszönöm.";
        var url = 'https://mail.google.com/mail/?view=cm&fs=1&to='+toAddress+'&su='+subject+'&body='+body;
        window.open(url, '_blank');
    }

    render(){
        return(
            <div className="page noRole">
                <div className="message">
                    Sikeresen regisztráltuk azonosítóját a KIG Radius rendszerbe.
                    <br />
                    <br />
                    Írjon egy e-mailt a rendszergazda@kig.hu címre (a most regisztrált címéről),
                    <br />
                    és kérje a wifi-azonosítók létrehozására vonatkozó engedély beállítását!
                    <br />
                    <br />
                    Ha megkapta a visszajelzést, bejelentkezhet a Radius rendszerbe.
                    <br /><br /><br />
                    <div onClick={this.onClick_email.bind(this)} className="btn btn-primary">Írok egy emailt most rögtön</div>
                </div>
            </div>
            
        )
    }
}

export default PageNoRole;